
// import React, { createContext, useContext, useState } from "react";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const storedUser = JSON.parse(localStorage.getItem("user")) || {};
//   const [userId, setUserId] = useState(storedUser.userId || "");
//   const [userEmail, setUserEmail] = useState(storedUser.userEmail || "");
//   const [userName, setUserName] = useState(storedUser.userName || "");

//   const login = (id, email, name) => {
//     setUserId(id);
//     setUserEmail(email);
//     setUserName(name);
//     localStorage.setItem(
//       "user",
//       JSON.stringify({ userId: id, userEmail: email, userName: name })
//     );
//   };

//   const logout = () => {
//     setUserId("");
//     setUserEmail("");
//     setUserName("");
//     localStorage.removeItem("user");
//   };

//   return (
//     <AuthContext.Provider value={{ userId, userEmail, userName, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const storedUser = JSON.parse(localStorage.getItem("user")) || {};
  const [userId, setUserId] = useState(storedUser.userId || "");
  const [userEmail, setUserEmail] = useState(storedUser.userEmail || "");
  const [userName, setUserName] = useState(storedUser.userName || "");
  const [userRole, setUserRole] = useState(storedUser.userRole || "");  // ← ADD

  const login = (id, email, name, role) => {    // ← ADD role param
    setUserId(id);
    setUserEmail(email);
    setUserName(name);
    setUserRole(role);                          // ← ADD
    localStorage.setItem(
      "user",
      JSON.stringify({ userId: id, userEmail: email, userName: name, userRole: role })  // ← ADD role
    );
  };

  const logout = () => {
    setUserId("");
    setUserEmail("");
    setUserName("");
    setUserRole("");                            // ← ADD
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ userId, userEmail, userName, userRole, login, logout }}>  {/* ← ADD userRole */}
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);